import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";
import { useEffect } from "react";
import { useLexicalContext } from "../lexical-context";
import { $isPollNode } from "../nodes/poll/helpers";
import { $findAllNodesOfType } from "./find-all-nodes-of-type";

export function useRemoveTeamsChannelPollNodes(): void {
  const [editor] = useLexicalComposerContext();
  const { toChannel, channelName } = useLexicalContext();
  const isTeamsChannel = channelName === "teams" && toChannel;

  useEffect(() => {
    // if polls are not enabled, remove all polls from the editor
    if (isTeamsChannel) {
      editor.update(
        () => {
          $findAllNodesOfType($getRoot(), $isPollNode).forEach((node) => {
            node.remove();
          });
        },
        { discrete: true },
      );
    }
  }, [editor, isTeamsChannel]);
}
